// extracted by mini-css-extract-plugin
export default {"container":"MaTapp88qdYu03WGd3kM"};